import React, { useState } from 'react';
import { parsePhoneList } from './parsePhoneList';

const Step1_Input = ({ onNext, loading, error, setError }) => {
  const [clid, setClid] = useState('DEMO0004');
  const [segmentName, setSegmentName] = useState('');
  const [pasteText, setPasteText] = useState('');

  const handleNext = () => {
    if (!clid.trim()) {
      setError('Please provide a CLID.');
      return;
    }
    const phones = parsePhoneList(pasteText);
    if (phones.length === 0) {
      setError('Please paste at least one valid phone number.');
      return;
    }
    setError('');
    onNext({ clid: clid.trim(), phones, segmentName: segmentName.trim() });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1">CLID</label>
        <input
          className="border rounded px-3 py-2 w-full"
          value={clid}
          onChange={(e) => setClid(e.target.value)}
          placeholder="e.g. DEMO0004"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Segment Name (optional)</label>
        <input
          className="border rounded px-3 py-2 w-full"
          value={segmentName}
          onChange={(e) => setSegmentName(e.target.value)}
          placeholder="Auto-generated if left empty"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">
          Phone Numbers (paste an Excel column, one number per line)
        </label>
        <textarea
          className="border rounded px-3 py-2 w-full h-56 font-mono text-sm"
          value={pasteText}
          onChange={(e) => setPasteText(e.target.value)}
          placeholder={'85297500300\n85220000000\n...'}
        />
        <p className="text-xs text-gray-500 mt-1">
          {parsePhoneList(pasteText).length} phone number(s) detected.
        </p>
      </div>

      {error && <p className="text-red-600 text-sm">{error}</p>}

      <button
        className="bg-[#075e54] text-white px-4 py-2 rounded disabled:opacity-50"
        onClick={handleNext}
        disabled={loading}
      >
        Next: Check Contacts
      </button>
    </div>
  );
};

export default Step1_Input;
